export default __webpack_public_path__ + "static/preloader-45b26071cb57bbe4285a7422dc02644b.gif";